export type { SidebarExplorePanelProps } from "./sidebar-explore-panel";
export { SidebarExplorePanel } from "./sidebar-explore-panel";
export type { SidebarLiquidButtonProps } from "./sidebar-liquid-button";
export { SidebarLiquidButton } from "./sidebar-liquid-button";
export type { SidebarLiquidRailProps } from "./sidebar-liquid-rail";
export { SidebarLiquidRail } from "./sidebar-liquid-rail";
export { SidebarMobileDrawer } from "./sidebar-mobile-drawer";
export type { SidebarProps } from "./sidebar-rail";
export { Sidebar } from "./sidebar-rail";
export type { SidebarNavItem, SidebarTone } from "./types";
export { useSidebarNavigation } from "./use-sidebar-navigation";

// ── Legacy / Classic sidebar components ──────────────────────────
export { default as SidebarBody } from "./sidebar-body";
export { default as SidebarContent } from "./sidebar-content";
export { default as SidebarFooter } from "./sidebar-footer";
export { default as SidebarFooterVersion } from "./sidebar-footer-version";
export { default as SidebarHeader } from "./sidebar-header";
export { ICONS_ACTIVE_VERSION, ICONS_MODULES_PATHS, isSvg } from "./sidebar-icon-modules-path";
export { default as SidebarLogo } from "./sidebar-logo";
export { default as SidebarMenuDropdownItem } from "./sidebar-menu-dropdown-item";
export { default as SidebarMenuItem } from "./sidebar-menu-item";
export { default as SidebarSpectrumBackground } from "./sidebar-spectrum-background";
export { default as SidebarTagVendor } from "./sidebar-tag-vendor";
export { default as SidebarToggleCompress } from "./sidebar-toggle-compress";
export { openBeamerChangelog } from "./sidebar-what-is-new";
